import React from 'react'

import Galaxy3 from './Galaxy3';
import GalaxyMobile from './GalaxyMobile'
//import GalaxyMobile from './GalaxyMobile';
import ReadMore from './ReadMore'
import BuroCrat from './BuroCrat';
//import BuroCratAdmin from './BuroCratAdmin';
import NewMobile from './NewMobile';
import New4 from './New4';
import Paid from './paid';
import Login from './login';
import LoginMobile from './loginMob';

import Registerpage from './registerpage';
import RegisterpageMob from './registerpageMob';

import Confirm from './confirm'
import Profile from './profile';
import Buy from './buy';
import BuyMobile from './buyMobile';
import Contact from './contact';

import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { isMobile } from 'react-device-detect';


import "./App.css"

function App() {
  

  return (
    <BrowserRouter basename='/'>
      <Routes >
         
        {!isMobile ?
          <>
            <Route path='/*' Component={Galaxy3} />
            <Route path="/:FilteredMessageid" Component={Galaxy3} />
            <Route path='/new/' Component={New4} />
            <Route path='/new/:id' Component={New4} />
            <Route path='/buy/:idea?' Component={Buy} />
            <Route path='/login' Component={Login} />
            <Route path='/register' Component={Registerpage} />
            <Route path='/profile' Component={Profile} />
            <Route path='/contact' Component={Contact} />
            
          </>
          :
          <>
            <Route path="/:FilteredMessageid" Component={GalaxyMobile}  />
            <Route path='/*' Component={GalaxyMobile} />
            <Route path='/new/' Component={NewMobile} />
            <Route path='/buy/:idea?' Component={BuyMobile} />
            <Route path='/login' Component={LoginMobile} />
            <Route path='/register' Component={RegisterpageMob} />
          </>
          }
        <Route path='/paid' Component={Paid} />
         <Route path='/about' Component={ReadMore} />
        <Route path='/confirm/:token?' Component={Confirm} />
        

          
          {/* !isMobile ? <Route path='/admin' Component={BuroCratAdmin} /> : "" */}
        {!isMobile ? <Route path='/listing' Component={BuroCrat} /> : ""}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
